module.exports = __webpack_public_path__ + "static/Irriglobe_Produits-481a341019604dcbadeb526dd051c361.mp4";